import React, { Component } from "react";
import jquery from "jquery";
import swal from "sweetalert";
import Tab from "react-bootstrap/Tab";
import { toast } from "react-toastify";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import axios from "../../../axios";
import apiError from "../../../error";
import Loader from "../../../component/loader/loader";
import Game from "../../../component/create-template/game/game";
import Pages from "../../../component/create-template/pages/pages";
import AwarenessPages from "../../../component/create-template/pages/awareness-page";
import Preview from "../../../component/create-template/preview/preview";
import NavTabs from "../../../component/create-template/nav-tabs/nav-tabs";
import Training from "../../../component/create-template/training/training";
import Templates from "../../../component/create-template/templates/templates";
import TemplatesSMS from "../../../component/create-template/templates-sms/templates-sms";
import CampaignName from "../../../component/create-template/campaign-name/campaign-name";
import TemplatesCall from "../../../component/create-template/templates-call/templates-call";
import AttackProfile from "../../../component/create-template/attacker-profile/attacker-profile";
import AttachmentTemplate from "../../../component/create-template/templates/attachment-template";
import GenerateTemplate from "../../../component/create-template/generate-template/generate-template";
import TemplatesWhatsApp from "../../../component/create-template/templates-message/templates-message";
import TemplatesTelegram from "../../../component/create-template/templates-telegram/templates-telegram";
import AttackProfileSMS from "../../../component/create-template/attacker-profile-sms/attacker-profile-sms";
import AttackProfileCall from "../../../component/create-template/attacker-profile-call/attacker-profile-call";
import AttackProfileWhatsApp from "../../../component/create-template/attacker-profile-whatsapp/attacker-profile-whatsapp";
import "./campaign.css";
import { SOCKET_EVENTS, socket } from "../../../socket";
import AttackProfileTelegram from "../../../component/create-template/attacker-profile-telegram/attacker-profile-telegram";
import AiConversation from "../../../component/create-template/ai-conversation/ai-conversation";
import VoiceSelection from "../../../component/create-template/voice-selection/voice-selection";
import RansomwareFile from "../../../component/create-template/ransomware-file/ransomware-file";
import { getCookie, isTruthyValue } from "../../../function";

export default class CampaignCreate extends Component {
	constructor(props) {
		super(props);
		const parsedId = parseInt(this.props.match.params.id, 10);
		this.state = {
			isSocketConnected: false,
			attack_type: [],
			templateName: "",
			simulation_type: [],
			campaignNameShow: true,
			generateTemplateShow: true,
			attackTypeId: -1,
			simulationTypeId: -1,
			attack_type_name: "",
			simulation_type_name: "",
			pageId: 0,
			gameId: 0,
			senderId: 0,
			templateId: 0,
			trainingId: 0,
			categoryId: 0,
			languageId: 0,
			loading: true,
			redisKey: "",
			showNextTab: false,
			disableState: false,
			senderType: "automatic",
			campaignNameLoading: false,
			credential_harvesting: false,
			// `/templates/ai` passes a non-numeric id ("ai"), so default to 0.
			campaignTemplateId: Number.isNaN(parsedId) ? 0 : parsedId,
			companyUrl: "",
			context: "",
			companyLogo: "",
			filePath: "",
			message: "",
			show: false,
			templateResponse: [],
			count: 5,
			htmlContent: "",
			subContent: "",
			generationAttemptsCount: "",
			tabBtn: true,
			tabValue: "information",
			activeTab: "first",
			generationAttempts: "",
			showColorLogoFeature: false,
			lang: false,
			currentIndex: 0,
			defaultColor: null,
			defaultColor1: "",
			defaultColor2: "",
			defaultColor3: "",
			defaultColor4: "",
			defaultColor5: "",
			colorIndex: 0,
			backgroundHeader: null,
			logoPosition: null,
			backgroundHeader1: "",
            backgroundHeader2: "",
            backgroundHeader3: "",
            backgroundHeader4: "",
            backgroundHeader5: "",
            logoPosition1: "",
            logoPosition2: "",
            logoPosition3: "",
            logoPosition4: "",
            logoPosition5: "",
			/* course template */
			sendCourseTemplateId: null,
			courseCompletionTemplateId: null,
			courseQuizFailReminderTemplateId: null,
			sendQuizTemplateId: null,
			tags: [],
			whatsappGateway: '',
			awarenessPageId: '',
			aiVishingPromptId: '',
			aiWhatsappPromptId: '',
			vishingVoiceSelectionId: '',
			voiceSelectionCompleted: false,
			voiceWizardVoiceId: "",
			targetInteractionType: "inbound",
			isAIbased: false,
			ransomwareFileCompleted: false,
		};
		this._lastVoiceStepHydrateSig = null;
	}

	load = async () => {
		if (this.state.campaignTemplateId) {
			axios
				.get("/api/campaign/template/" + this.state.campaignTemplateId, {})
				.then((res) => {
					this.setState({
						loading: false,
						pageId: res.data.campaign_template.pageId,
						gameId: res.data.campaign_template.gameId,
						templateName: res.data.campaign_template.name,
						senderId: res.data.campaign_template.senderId,
						aiVishingPromptId: res.data.campaign_template.aiVishingPromptId,
						aiWhatsappPromptId: res.data.campaign_template.aiWhatsappPromptId,
						vishingVoiceSelectionId: res.data.campaign_template.vishingVoiceSelectionId || '',
						trainingId: res.data.campaign_template.courseId,
						templateId: res.data.campaign_template.templateId,
						senderType: res.data.campaign_template.senderType,
						categoryId: res.data.campaign_template.categoryId,
						languageId: res.data.campaign_template.languageId,
						attackTypeId: res.data.campaign_template.attackTypeId,
						simulationTypeId: res.data.campaign_template.simulationTypeId,
						// simulationTypeId is null on templates now; lock the Attack
						// Vector on edit based on the stored attackTypeId instead.
						disableState: res.data.campaign_template.attackTypeId ? true : false,
						credential_harvesting: res.data.campaign_template.credential_harvesting,
						targetInteractionType: res.data.campaign_template.targetInteractionType,
						isAIbased: res.data.campaign_template.isAIbased,
						/* course template */
						sendCourseTemplateId: res.data.campaign_template.sendCourseTemplateId,
						courseCompletionTemplateId: res.data.campaign_template.courseCompletionTemplateId,
						courseQuizFailReminderTemplateId: res.data.campaign_template.courseQuizFailReminderTemplateId,
						sendQuizTemplateId: res.data.campaign_template.sendQuizTemplateId,
						tags: res.data.campaign_template?.campaign_template_tags?.map(tag => {return {label: tag.tagName, value: tag.tagName, __isNew__: true}}) || [],
						voiceSelectionCompleted: false,
						voiceWizardVoiceId: "",
					}, () => {
						this._lastVoiceStepHydrateSig = null;
						this.loadSimulaitonType();
					});
				})
				.catch((error) => {
					this.setState({ loading: false });
					apiError(error);
				});
		} else {
			this.loadSimulaitonType();
		}
	};

	isTemplateAiBasedEnabled = () => {
		const v = this.state.isAIbased;
		return v === true || v === 1 || String(v).toLowerCase() === "true";
	};

	loadSimulaitonType = async () => {
		this.setState({ loading: true });
		try {
			/* Templates are simulation-type-agnostic in the UI: the Attack Vector
			   dropdown must show every attack vector regardless of simulation type.
			   We fetch ALL simulation types (both "Simulation Attack" and
			   "Simulation Attack + Training" — no context=template filter) and merge
			   their attack vectors, deduped by attackTypeId. The backend still stores
			   a simulationTypeId per template, so each merged vector keeps its owning
			   simulationTypeId (resolved on selection in handleAttackType). */
			const typeRes = await axios.get("/api/simulation/type");
			/* order so "Simulation Attack" wins on duplicate attack vectors */
			const simList = (typeRes.data.simulation_type || []).slice().sort((a, b) => {
				if (a.name === "Simulation Attack") return -1;
				if (b.name === "Simulation Attack") return 1;
				return 0;
			});

			const attackLists = await Promise.all(
				simList.map((s) =>
					axios
						.get("/api/simulation/type/" + s.id, {})
						.then((r) => r.data.simulation_attack || [])
						.catch(() => [])
				)
			);

			/* merge + dedupe by attackTypeId (first occurrence wins → Simulation Attack) */
			const merged = [];
			const seen = new Set();
			attackLists.forEach((list) => {
				list.forEach((row) => {
					const at = row && row.attack_type;
					if (!at || at.id == null || seen.has(at.id)) return;
					seen.add(at.id);
					merged.push(row);
				});
			});

			/* resolve names for an already-selected type/vector (edit flow) */
			const wantAttackId = Number(this.state.attackTypeId);
			const selectedVector = merged.find((row) => Number(row.attack_type.id) === wantAttackId);
			const attack_type_name = selectedVector ? selectedVector.attack_type.name : this.state.attack_type_name;

			/* simulationTypeId is no longer stored on templates (they're
			   simulation-type-agnostic), so on reload/edit it can't be resolved
			   directly. Derive the wizard's simulation type from the selected
			   attack vector's owning simulationTypeId — the merge above kept the
			   "Simulation Attack" row first on dedupe, so this prefers it.
			   Without this the flow name is "" and NavTabs falls back to a
			   Phishing-shaped generic tab list, blanking the next step for
			   non-Phishing vectors. This stays local state only and is never sent
			   to the backend. */
			const wantSimId = Number(this.state.simulationTypeId);
			let wantedType = simList.find((s) => Number(s.id) === wantSimId);
			if (!wantedType && selectedVector) {
				wantedType = simList.find(
					(s) => Number(s.id) === Number(selectedVector.simulationTypeId)
				);
			}
			const simulation_type_name = wantedType ? wantedType.name : this.state.simulation_type_name;
			const resolvedSimulationTypeId = wantedType ? wantedType.id : this.state.simulationTypeId;

			this.setState(
				{
					loading: false,
					simulation_type: simList,
					simulation_type_name,
					simulationTypeId: resolvedSimulationTypeId,
					attack_type: merged,
					attack_type_name,
					showNextTab: true,
				},
				() => {
					this._lastVoiceStepHydrateSig = null;
					const sig = this.getVoiceStepHydrateSignature();
					if (sig != null) {
						this._lastVoiceStepHydrateSig = sig;
						this.hydrateVoiceSelectionStepCompletion(sig);
					}
					if (attack_type_name === "Ransomware" && this.state.pageId) {
						this.hydrateRansomwareFileCompletion(this.state.pageId);
					}
				}
			);
		} catch (error) {
			this.setState({ loading: false });
			apiError(error);
		}
	};

	handleSimulationType = async (e) => {
		let simulation_type = JSON.parse(e.target.value);
		this.setState({
			attackTypeId: -1,
			attack_type_name: "",
			simulationTypeId: simulation_type.id,
			simulation_type_name: simulation_type.name,
		});
		if (parseInt(simulation_type.id, 10) !== -1) {
			this.setState({ loading: true });
			axios
				.get("/api/simulation/type/" + simulation_type.id, {})
				.then((res) => this.setState({ attack_type: res.data.simulation_attack, loading: false, showNextTab: true }))
				.catch((error) => {
					apiError(error);
					this.setState({ loading: false });
				});
		} else {
			this.setState({ attack_type: [] });
		}
	};

	handleHarvesting = () => {
		this.setState({ credential_harvesting: !this.state["credential_harvesting"] });
	};

	handleAttackType = async (e) => {
		let attack_type = JSON.parse(e.target.value);
		const hasInteractionMode = attack_type.name === "Vishing" || attack_type.name === "WhatsApp";
		/* Derive the owning simulationTypeId from the selected vector so the
		   backend still receives a valid type (validation + storage) even though
		   the simulation-type selector is hidden. Prefers the "Simulation Attack"
		   mapping since dedupe kept that row first. */
		const owningVector = (this.state.attack_type || []).find(
			(row) => row.attack_type && Number(row.attack_type.id) === Number(attack_type.id)
		);
		const owningType =
			owningVector &&
			(this.state.simulation_type || []).find((s) => Number(s.id) === Number(owningVector.simulationTypeId));
		this.setState({
			attackTypeId: attack_type.id,
			attack_type_name: attack_type.name,
			...(owningVector ? { simulationTypeId: owningVector.simulationTypeId } : {}),
			...(owningType ? { simulation_type_name: owningType.name } : {}),
			...(hasInteractionMode
				? { targetInteractionType: "", isAIbased: null, credential_harvesting: false }
				: {}),
		});
		if (attack_type.name === "Ransomware") {
			this.setState({ credential_harvesting: true, ransomwareFileCompleted: false });
		} else {
			this.setState({ ransomwareFileCompleted: false });
		}
	};

	handleSenderType = () => {
		axios
			.post("/api/campaign/template/senderType/" + this.state.campaignTemplateId, {})
			.then((res) => this.setState({ senderType: res.data.senderType }))
			.catch((error) => apiError(error));
	};

	handleCampaignName = (e) => {
		this.setState({ templateName: e.target.value });
	};

	handleCampaignNameShow = () => {
		this.setState({ campaignNameShow: !this.state.campaignNameShow });
	};

	handleSenderId = (senderId) => {
		this.setState({ senderId: senderId });
	};

	componentDidMount = () => {
		this.initializeSocket();
		// Opened via "Proceed" after cloning a draft system template — land on the last (Preview) tab
		// so the user can review and save the cloned template before running the campaign.
		const search = (this.props.location && this.props.location.search) || window.location.search || "";
		this.openPreviewTab = new URLSearchParams(search).get("preview") === "1";
		this.load();
		const pathname = window.location.pathname;
		if (pathname === "/templates/ai") {
			this.setState({ generateTemplateShow: false, templateResponse: [] });
		}
	};

	componentDidUpdate(prevProps, prevState) {
		const sig = this.getVoiceStepHydrateSignature();
		if (sig == null) {
			if (this._lastVoiceStepHydrateSig != null) {
				this._lastVoiceStepHydrateSig = null;
			}
			return;
		}
		if (sig === this._lastVoiceStepHydrateSig) {
			return;
		}
		this._lastVoiceStepHydrateSig = sig;
		this.hydrateVoiceSelectionStepCompletion(sig);
	}

	getVoiceStepHydrateSignature = () => {
		const {
			attack_type_name,
			targetInteractionType,
			campaignTemplateId,
			vishingVoiceSelectionId,
		} = this.state;
		if (attack_type_name !== "Vishing" || targetInteractionType !== "inbound") return null;
		if (!campaignTemplateId) return null;
		if (vishingVoiceSelectionId == null || String(vishingVoiceSelectionId).trim() === "") return null;
		return `${campaignTemplateId}|v|${String(vishingVoiceSelectionId)}`;
	};

	isVoiceDeepfakeEnabled = () => isTruthyValue(getCookie("isDeepFakeEnabled"));

	hydrateVoiceSelectionStepCompletion = (sig) => {
		const { vishingVoiceSelectionId } = this.state;
		if (!vishingVoiceSelectionId) return;

		axios
			.get(`/api/vishing-voice-selection/${vishingVoiceSelectionId}`)
			.then((res) => {
				if (this.getVoiceStepHydrateSignature() !== sig) return;
				const voiceSel = res.data?.vishingVoiceSelection || res.data?.data?.vishingVoiceSelection || {};
				const rawVid = voiceSel.voiceId;
				const hasVid = rawVid != null && String(rawVid).trim() !== "";
				const nextWizardVid = hasVid ? String(rawVid) : "";
				this.setState((prev) => {
					if (prev.voiceSelectionCompleted === hasVid && prev.voiceWizardVoiceId === nextWizardVid) return null;
					return { voiceSelectionCompleted: hasVid, voiceWizardVoiceId: nextWizardVid };
				});
			})
			.catch(() => {
				if (this.getVoiceStepHydrateSignature() === sig) {
					this._lastVoiceStepHydrateSig = null;
				}
			});
	};

	handleAiVishingPromptId = (aiVishingPromptId) => {
		this.setState((prev) => {
			if (String(prev.aiVishingPromptId ?? "") !== String(aiVishingPromptId ?? "")) {
				return { aiVishingPromptId };
			}
			return { aiVishingPromptId };
		});
	};

	// Called when VoiceSelection lazily creates a new vishing_voice_selection record
	handleVishingVoiceSelectionCreated = (vishingVoiceSelectionId) => {
		this.setState((prev) => {
			if (String(prev.vishingVoiceSelectionId ?? '') !== String(vishingVoiceSelectionId ?? '')) {
				this._lastVoiceStepHydrateSig = null;
				return { vishingVoiceSelectionId, voiceSelectionCompleted: false, voiceWizardVoiceId: '' };
			}
			return null;
		});
	};

	handleAiWhatsappPromptId = (aiWhatsappPromptId) => {
		this.setState((prev) => {
			if (String(prev.aiWhatsappPromptId ?? "") !== String(aiWhatsappPromptId ?? "")) {
				return { aiWhatsappPromptId };
			}
			return { aiWhatsappPromptId };
		});
	};

	handleVoiceSelectionStepComplete = () => {
		this.setState({ voiceSelectionCompleted: true });
	};

	handleTemplateId = (templateId) => {
		this.setState({ templateId: templateId });
	};

	handlePageId = (pageId) => {
		this.setState({ pageId: pageId }, () => {
			this.hydrateRansomwareFileCompletion(pageId);
		});
	};

	handleRansomwareFileComplete = () => {
		this.setState({ ransomwareFileCompleted: true });
	};

	hydrateRansomwareFileCompletion = (pageId) => {
		if (
			this.state.attack_type_name !== "Ransomware" ||
			!pageId ||
			parseInt(pageId, 10) === 0
		) {
			return;
		}
		axios
			.get("/api/pages/" + pageId, {})
			.then((res) => {
				const page = res.data.page || {};
				const fileName = page.ransonware_file || "";
				const fileId = page.ransomwareFileId || 0;
				const completed =
					fileName &&
					String(fileName).trim().length > 0 &&
					parseInt(fileId, 10) > 0;
				if (completed) {
					this.setState({ ransomwareFileCompleted: true });
				}
			})
			.catch(() => {});
	};

	handleCategoryId = (e) => {
		this.setState({ categoryId: e.target.value });
	};

	handleLanguageId = (e) => {
		let langValue = e.target[e.target.value].text;
		if (langValue === "Arabic" || langValue === "Urdu" || langValue === "Persian" || langValue === "Turkish") {
			this.setState({ lang: true });
			this.setState({ languageId: e.target.value });
		} else this.setState({ lang: false });
		this.setState({ languageId: e.target.value });
	};

	handleTraining = (trainingId) => {
		this.setState({ trainingId: trainingId });
	};

	handleCompanyUrl = (e) => {
		this.setState({ companyUrl: e.target.value });
	};
	handleContext = (e) => {
		this.setState({ context: e.target.value });
	};
	handleClose = () => {
		this.setState({ show: false });
	};

	handleValidateAI = () => {
		//eslint-disable-next-line
		const urlRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
		if (this.state.companyUrl.length === 0 || this.state.companyUrl.trim().length === 0 || !urlRegex.test(this.state.companyUrl)) {
			toast.error("Please Enter Valid Company URL");
			return false;
		} else if (this.state.context.length === 0 || this.state.context.trim().length === 0) {
			toast.error("Please Enter Context");
			return false;
		} else if (this.state.filePath.length === 0 || this.state.filePath.trim().length === 0) {
			toast.error("Please Select Company Logo");
			return false;
		} else if (this.state.languageId === 0 || this.state.languageId.trim().length === 0) {
			toast.error("Please Select Language");
		}
		return {
			companyUrl: this.state.companyUrl,
			context: this.state.context,
			filePath: this.state.filePath,
			languageId: this.state.languageId,
		};
	};

	validateInfoTemplate = (key) => {
		let data = this.handleValidate();
		if (data) {
			this.setState({ tabBtn: false, tabValue: key });
		}
	};

	previousTab = () => {
		this.setState({ tabBtn: false, tabValue: "information" });
	};

	initializeSocket() {
		if (!socket.connected) socket.connect();
		else this.setState({ isSocketConnected: true })

		socket.on('connect', () => {
			this.setState({ isSocketConnected: true })
		}, function (error) {});
		
		socket.on('disconnect', () => {
			this.setState({ isSocketConnected: false });
		})

		socket.on(SOCKET_EVENTS.AI_TEMPLATE_DATA, this.saveAiTemplate.bind(this))
	}

	saveAiTemplate = (response) => {
		this.setState({ loading: false });
		let regexForSubject = /<h2\s*id=['"]emailSubject['"]>(.*?)<\/h2>/i;
		let aiTemplateSubjectHtml = response.content;
		let match = aiTemplateSubjectHtml.match(regexForSubject);
		let subjectMatched;
		if (match) subjectMatched = match[1];
		else subjectMatched = "";

		let removedContent = aiTemplateSubjectHtml.replace(regexForSubject, "").trim();

		this.setState({ [`defaultColor${this.state.colorIndex + 1}`]: response.color });
		this.setState({ [`logoPosition${this.state.colorIndex + 1}`]: "left" });
		this.setState({[`backgroundHeader${this.state.colorIndex + 1}`]: response.color})

		let value = this.state.colorIndex + 1;
		this.setState({ colorIndex: value })

		this.setState({ showColorLogoFeature: true });
		this.setState({
			htmlContent: removedContent,
			count: this.state.count - 1,
			generationAttempts: response.generationAttempts,
			subContent: subjectMatched,
		});
		let newTemplateResponse = [...this.state.templateResponse];
		newTemplateResponse.push(removedContent);
		const MAX_RESPONSES = 10; // adjust this value to your desired limit
		if (newTemplateResponse.length > MAX_RESPONSES) {
			newTemplateResponse.shift();
		}

		this.setState({ templateResponse: newTemplateResponse });
		this.setState({defaultColor: response.color})
		this.setState({logoPosition: "left"})
	}

	updateCurrentIndex = (newIndex) => {
        this.setState({ currentIndex: newIndex });
    };

	updateDefaultColor = (defaultColor) => {
		this.setState({ defaultColor: defaultColor });
	}
	updateBackgroundHeader = (bgHeader) => {
		this.setState({ backgroundHeader: bgHeader });
	}
	updateBackgroundHeaderWithIdx = (backgroundHeader, idx) => {
		this.setState({
            [`backgroundHeader${idx + 1}`]: backgroundHeader,
        });
	}

	updateLogoPosition = (logoPos) => {
		this.setState({ logoPosition: logoPos });
	}
	updateLogoPositionWithIdx = (logoPosition, idx) => {
		this.setState({
			[`logoPosition${idx + 1}`]: logoPosition
		});
	}

	handleGenerateAi = async () => {
		try {
			if (this.state.templateResponse.length >= 5) {
				toast.error('You Have Reached Your Maximum Limit For Template Generation. Please Select Anyone Template To Proceed.');
				socket.disconnect();
				return;
			}
			if (!this.state.isSocketConnected) return console.log("Socket Still Not Connected")
			let data = this.handleValidateAI();
			if (data) {
				this.setState({ loading: true })
				const res = await axios.post("/api/campaign/template/generate", data)
				if (res) {
					this.findAttempts();
				} else this.setState({ loading: false });
			}
		} catch (err) {
			this.setState({ loading: false });
			apiError(err);
		};
	}

	handleAPiForImage = (formData) => {
		axios
			.post("/api/campaign/template/generate/asset", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((res) => {
				this.setState({ filePath: res.data.filePath });
			})
			.catch((error) => { });
	};

	handleCompanyLogo = (e) => {
		if (e.target.files.length > 0) {
			this.setState({ companyLogo: e.target.files[0].name });
			let formData = new FormData();
			formData.append("companyLogo", e.target.files[0]);
			this.handleAPiForImage(formData);
		} else if (e.target.files.length === 0) {
			this.setState({ filePath: "" });
			this.setState({ companyLogo: "" });
		}
	};

	nextPath = (path) => {
		this.props.history.push(path);
	};

	handleTabChange = (type) => {
		try {
			const activeTab = this.state.activeTab;

			// Vishing inbound: same order as `campaignTabs` vishingStates.inbound (jQuery next/prev is unreliable here).
			if (this.state.attack_type_name === "Vishing" && this.state.targetInteractionType === "inbound") {
				const chain = [
					"first",
					"third",
					"third_ai_conversation",
					"voice_selection",
					"second",
					"nine",
				];
				const idx = chain.indexOf(activeTab);
				if (idx !== -1) {
					if (type === "next" && idx < chain.length - 1) {
						setTimeout(() => this.setState({ activeTab: chain[idx + 1] }), 0);
						return;
					}
					if (type === "prev" && idx > 0) {
						setTimeout(() => this.setState({ activeTab: chain[idx - 1] }), 0);
						return;
					}
				}
			}

			if (this.state.attack_type_name === "Ransomware") {
				const chain = ["first", "third", "fourth", "fifth", "second", "nine"];
				const idx = chain.indexOf(activeTab);
				if (idx !== -1) {
					if (type === "next" && idx < chain.length - 1) {
						setTimeout(() => this.setState({ activeTab: chain[idx + 1] }), 0);
						return;
					}
					if (type === "prev" && idx > 0) {
						setTimeout(() => this.setState({ activeTab: chain[idx - 1] }), 0);
						return;
					}
				}
			}

			// WhatsApp: explicit tab keys — jQuery .next() fails (Nav.Link has no id) on every step after Template Name.
			if (this.state.attack_type_name === "WhatsApp") {
				const isAiWhatsapp =
					this.state.targetInteractionType === "inbound" &&
					this.state.isAIbased === true;

				let chain;
				if (isAiWhatsapp) {
					chain = ["first", "third", "third_ai_conversation", "second", "nine"];
				} else {
					chain = ["first", "second-sms", "third-sms", "fourth", "eight", "nine"];
					// Landing page ("fourth") is included per attack vector now, not by the
					// removed credential-harvesting toggle. Campaign-level CH decides at runtime
					// whether the landing page is served.
				}

				const idx = chain.indexOf(activeTab);
				if (idx !== -1) {
					if (type === "next" && idx < chain.length - 1) {
						setTimeout(() => this.setState({ activeTab: chain[idx + 1] }), 0);
						return;
					}
					if (type === "prev" && idx > 0) {
						setTimeout(() => this.setState({ activeTab: chain[idx - 1] }), 0);
						return;
					}
				}
			}
			setTimeout(function () {
				if (type === "next") {
					let tabId = jquery(".nav-link.active").parent().next().find("a").attr("id");
					document.getElementById(tabId).click();
				} else {
					let tabId = jquery(".nav-link.active").parent().prev().find("a").attr("id");
					document.getElementById(tabId).click();
				}
			}, 0);
		} catch (err) {
			console.log(err);
		}
	};

	handleAwarenessPageId = (awarenessPageId) => {
		this.setState({ awarenessPageId: awarenessPageId });
	}

	findAttempts = () => {
		axios
			.get("/api/campaign/template/generate/generationAttempts")
			.then((res) => {
				let attempts = JSON.stringify(res.data.generationAttempts.generationAttempts);
				this.setState({ generationAttemptsCount: attempts });
				if (this.state.generationAttemptsCount === "0") {
					this.setState({ loading: false });
					swal({
						title: "You have reached Maximum Attempt limits",
						icon: "warning",
						confirmButtonText: "Redirect",
					}).then((result) => {
						if (result) {
							window.location.href = "/templates/ai";
						} else {
							swal("Cancelled", "Your action was canceled.", "info");
						}
					});
				}
			})
			.catch((err) => {
				this.setState({ loading: false });
				apiError(err)
			});
	};

	handleValidate = () => {
		if (this.state.templateName.length === 0 || this.state.templateName.trim().length === 0) {
			toast.error("Please Enter Template Name");
			return false;
		} else if (parseInt(this.state.categoryId, 10) === -1 || parseInt(this.state.categoryId, 10) === 0) {
			toast.error("Please Select Category");
			return false;
		} else if (parseInt(this.state.languageId, 10) === 0) {
			toast.error("Please Select Language");
			return false;
		} else if (parseInt(this.state.attackTypeId, 10) === -1) {
			toast.error("Please Select Attack Vector");
			return false;
		} else if (
			(this.state.attack_type_name === "Vishing" || this.state.attack_type_name === "WhatsApp") &&
			this.state.targetInteractionType !== "inbound" &&
			this.state.targetInteractionType !== "outbound"
		) {
			toast.error(`Please Select ${this.state.attack_type_name} Mode`);
			return false;
		}
		return {
			// simulationTypeId is intentionally NOT sent: templates are
			// simulation-type-agnostic and credential_harvesting is a campaign-level setting now.
			categoryId: this.state.categoryId,
			languageId: this.state.languageId,
			attackTypeId: this.state.attackTypeId,
			name: this.state.templateName.trim(),
			tags: this.state.tags? this.state.tags.map(tag => tag.value) : [],
			targetInteractionType: this.state.targetInteractionType,
			isAIbased: this.state.isAIbased
		};
	};
	handleCreateCampaignTemplate = async (e, index) => {
		if (index) await this.setState({ currentIndex: index })
		const data = this.handleValidate();
		if (data) {
			if (this.state.campaignTemplateId > 0) {
				this.setState({ campaignNameLoading: true, loading: true });
				axios
					.patch("/api/campaign/template/" + this.state.campaignTemplateId, data)
					.then(() => {
						this.setState({ campaignNameShow: false, campaignNameLoading: false, loading: false });
						this.handleTabChange("next");
					})
					.catch((error) => {
						this.setState({ campaignNameLoading: false, loading: false });
						apiError(error);
					});
			} else {
				await this.setState({ loading: true });
				axios
					.post("/api/campaign/template", data)
					.then((res) => {
						toast.success("Campaign Template Created Successfully");
						this.setState({
							loading: false,
							disableState: true,
							campaignNameShow: false,
							senderType: res.data.campaign_template.senderType,
							campaignTemplateId: res.data.campaign_template.id,
						});
						this.props.history.push("/templates/" + res.data.campaign_template.id);
						this.handleTabChange("next");
					})
					.catch((error) => {
						this.setState({ loading: false });
						apiError(error);
					});
			}
		}
	};
	setTags = async (tagValues) => {
		this.setState({tags: tagValues})
	}
	handleWhatsappGateway = (whatsappGateway) => {
		this.setState({whatsappGateway: whatsappGateway})
	}

	handleTargetInteractionType = (type) => {
		this.setState({targetInteractionType: type})
	}

	handleAIbased = (isAIbased) => {
		this.setState({isAIbased: isAIbased})
		if(isAIbased){
			this.setState({targetInteractionType: "inbound"})
		}else{
			this.setState({targetInteractionType: "outbound"})
		}
	}

	render() {
		// Keep AI Template (Beta) UX unchanged: it has its own internal tabs in `GenerateTemplate`,
		// so don't show the left-side wizard tabs on `/templates/ai`.
		if (window.location.pathname === "/templates/ai") {
			return (
				<div className="content-wrap">
					<div className="breadcrumbbar">
						<div className="flexRow row">
							<div className="col-md-4">
								<div className="page-head d-flex align-items-cEnter justify-content-between">
									<h4 className="page-title">
										<a href="" onClick={(e) => this.props.history.push("/templates")} className="bar_Icons mr-2"><ArrowBackSharpIcon className="btn-icon" />
										</a>Create Template</h4>
								</div>
							</div>
							<div className="col-md-8 flexFilterButtons"></div>
						</div>
					</div>

					<div className="page-content">
						<GenerateTemplate
							categoryId={this.state.categoryId}
							languageId={this.state.languageId}
							showNextTab={this.state.showNextTab}
							attack_type={this.state.attack_type}
							disableState={this.state.disableState}
							templateName={this.state.templateName}
							attackTypeId={this.state.attackTypeId}
							handleTabChange={this.handleTabChange}
							handleHarvesting={this.handleHarvesting}
							handleAttackType={this.handleAttackType}
							handleCategoryId={this.handleCategoryId}
							handleLanguageId={this.handleLanguageId}
							lang={this.state.lang}
							attackTypeName={this.state.attack_type_name}
							simulation_type={this.state.simulation_type}
							handleCampaignName={this.handleCampaignName}
							simulationTypeId={this.state.simulationTypeId}
							handleSimulationType={this.handleSimulationType}
							campaignTemplateId={this.state.campaignTemplateId}
							simulationTypeName={this.state.simulation_type_name}
							campaignNameLoading={this.state.campaignNameLoading}
							handleCampaignNameShow={this.handleCampaignNameShow}
							credential_harvesting={this.state.credential_harvesting}
							handleCreateCampaignTemplate={this.handleCreateCampaignTemplate}
							companyUrl={this.state.companyUrl}
							context={this.state.context}
							companyLogo={this.state.companyLogo}
							show={this.state.show}
							handleCompanyUrl={this.handleCompanyUrl}
							handleContext={this.handleContext}
							handleCompanyLogo={this.handleCompanyLogo}
							handleGenerateAi={this.handleGenerateAi}
							handleClose={this.handleClose}
							count={this.state.count}
							htmlContent={this.state.htmlContent}
							templateResponse={this.state.templateResponse}
							validateInfoTemplate={this.validateInfoTemplate}
							previousTab={this.previousTab}
							tabBtn={this.state.tabBtn}
							tabValue={this.state.tabValue}
							generationAttempts={this.state.generationAttempts}
							showColorLogoFeature={this.state.showColorLogoFeature}
							currentIndex={this.state.currentIndex}
							updateCurrentIndex={this.updateCurrentIndex}
							defaultColor={this.state.defaultColor}
							updateDefaultColor={this.updateDefaultColor}
							updateBackgroundHeader={this.updateBackgroundHeader}
							updateLogoPosition={this.updateLogoPosition}
							backgroundHeader={this.state.backgroundHeader}
							logoPosition={this.state.logoPosition}
							backgroundHeader1={this.state.backgroundHeader1}
							backgroundHeader2={this.state.backgroundHeader2}
							backgroundHeader3={this.state.backgroundHeader3}
							backgroundHeader4={this.state.backgroundHeader4}
							backgroundHeader5={this.state.backgroundHeader5}
							logoPosition1={this.state.logoPosition1}
							logoPosition2={this.state.logoPosition2}
							logoPosition3={this.state.logoPosition3}
							logoPosition4={this.state.logoPosition4}
							logoPosition5={this.state.logoPosition5}
							updateBackgroundHeaderWithIdx={this.updateBackgroundHeaderWithIdx}
							updateLogoPositionWithIdx={this.updateLogoPositionWithIdx}
							defaultColor1={this.state.defaultColor1}
							defaultColor2={this.state.defaultColor2}
							defaultColor3={this.state.defaultColor3}
							defaultColor4={this.state.defaultColor4}
							defaultColor5={this.state.defaultColor5}
						></GenerateTemplate>
					</div>
					{this.state.loading ? <Loader></Loader> : null}
				</div>
			);
		}

		const isAiWhatsapp = this.state.attack_type_name === "WhatsApp" && this.state.targetInteractionType === "inbound" && this.state.isAIbased;
		const isNormalWhatsapp = this.state.attack_type_name === "WhatsApp" && !isAiWhatsapp;

		return (
			<div className="content-wrap">
				<div className="breadcrumbbar">
					<div className="flexRow row">
						<div className="col-md-4">
							<div className="page-head d-flex align-items-cEnter justify-content-between">
								<h4 className="page-title">
									<a href="" onClick={(e) => this.props.history.push("/templates")} className="bar_Icons mr-2"><ArrowBackSharpIcon className="btn-icon" />
									</a>Create Template</h4>
							</div>
						</div>
						<div className="col-md-8 flexFilterButtons">
						</div>
					</div>
				</div>
				<div className="page-content template-wizard">
					<Tab.Container
						id="left-tabs-example"
						activeKey={this.state.activeTab}
						onSelect={(activeTab) => this.setState({ activeTab })}
					>
						<div className="row create-tab template-wizard-row">
							<div className="col-md-3 left tempalte-nav-tab campaign-wizard-sidebar">
								<NavTabs
									activeTabKey={this.state.activeTab}
									pageId={this.state.pageId}
									gameId={this.state.gameId}
									senderId={this.state.senderId}
									aiVishingPromptId={this.state.aiVishingPromptId}
									aiWhatsappPromptId={this.state.aiWhatsappPromptId}
									vishingVoiceSelectionId={this.state.vishingVoiceSelectionId}
									templateId={this.state.templateId}
									trainingId={this.state.trainingId}
									awarenessPageId={this.state.awarenessPageId}
									attack_type={this.state.attack_type_name}
									simulation_type={this.state.simulation_type_name}
									campaignTemplateId={this.state.campaignTemplateId}
									handleCampaignNameShow={this.handleCampaignNameShow}
									credential_harvesting={this.state.credential_harvesting}
									targetInteractionType={this.state.targetInteractionType}
									isAIbased={this.state.isAIbased}
									isVoiceDeepfakeEnabled={this.isVoiceDeepfakeEnabled()}
									voiceSelectionCompleted={this.state.voiceSelectionCompleted}
									voiceId={this.state.voiceWizardVoiceId}
									ransomwareFileCompleted={this.state.ransomwareFileCompleted}
								></NavTabs>
							</div>
							<div className="col-md-9 contentRgt template-wizard-main">
								<Tab.Content>
									<Tab.Pane eventKey="first">
										{this.state.generateTemplateShow ? (
											<CampaignName
												categoryId={this.state.categoryId}
												languageId={this.state.languageId}
												showNextTab={this.state.showNextTab}
												attack_type={this.state.attack_type}
												disableState={this.state.disableState}
												templateName={this.state.templateName}
												attackTypeId={this.state.attackTypeId}
												handleTabChange={this.handleTabChange}
												handleHarvesting={this.handleHarvesting}
												handleAttackType={this.handleAttackType}
												handleCategoryId={this.handleCategoryId}
												handleLanguageId={this.handleLanguageId}
												attackTypeName={this.state.attack_type_name}
												simulation_type={this.state.simulation_type}
												handleCampaignName={this.handleCampaignName}
												simulationTypeId={this.state.simulationTypeId}
												handleSimulationType={this.handleSimulationType}
												campaignTemplateId={this.state.campaignTemplateId}
												simulationTypeName={this.state.simulation_type_name}
												campaignNameLoading={this.state.campaignNameLoading}
												handleCampaignNameShow={this.handleCampaignNameShow}
												credential_harvesting={this.state.credential_harvesting}
												handleCreateCampaignTemplate={this.handleCreateCampaignTemplate}
												lang={this.state.lang}
												tags={this.state.tags}
												setTags={this.setTags}
												handleTargetInteractionType={this.handleTargetInteractionType}
												handleAIbased={this.handleAIbased}
												isAIbased={this.state.isAIbased}
												targetInteractionType={this.state.targetInteractionType}
											></CampaignName>
										) : (
											<GenerateTemplate
												categoryId={this.state.categoryId}
												languageId={this.state.languageId}
												showNextTab={this.state.showNextTab}
												attack_type={this.state.attack_type}
												disableState={this.state.disableState}
												templateName={this.state.templateName}
												attackTypeId={this.state.attackTypeId}
												handleTabChange={this.handleTabChange}
												handleHarvesting={this.handleHarvesting}
												handleAttackType={this.handleAttackType}
												handleCategoryId={this.handleCategoryId}
												handleLanguageId={this.handleLanguageId}
												lang={this.state.lang}
												attackTypeName={this.state.attack_type_name}
												simulation_type={this.state.simulation_type}
												handleCampaignName={this.handleCampaignName}
												simulationTypeId={this.state.simulationTypeId}
												handleSimulationType={this.handleSimulationType}
												campaignTemplateId={this.state.campaignTemplateId}
												simulationTypeName={this.state.simulation_type_name}
												campaignNameLoading={this.state.campaignNameLoading}
												handleCampaignNameShow={this.handleCampaignNameShow}
												credential_harvesting={this.state.credential_harvesting}
												handleCreateCampaignTemplate={this.handleCreateCampaignTemplate}
												companyUrl={this.state.companyUrl}
												context={this.state.context}
												companyLogo={this.state.companyLogo}
												show={this.state.show}
												handleCompanyUrl={this.handleCompanyUrl}
												handleContext={this.handleContext}
												handleCompanyLogo={this.handleCompanyLogo}
												handleGenerateAi={this.handleGenerateAi}
												handleClose={this.handleClose}
												count={this.state.count}
												htmlContent={this.state.htmlContent}
												templateResponse={this.state.templateResponse}
												validateInfoTemplate={this.validateInfoTemplate}
												previousTab={this.previousTab}
												tabBtn={this.state.tabBtn}
												tabValue={this.state.tabValue}
												generationAttempts={this.state.generationAttempts}
												showColorLogoFeature={this.state.showColorLogoFeature}
												currentIndex={this.state.currentIndex}
												updateCurrentIndex={this.updateCurrentIndex}
												defaultColor={this.state.defaultColor}
												updateDefaultColor={this.updateDefaultColor}
												updateBackgroundHeader={this.updateBackgroundHeader}
												updateLogoPosition={this.updateLogoPosition}
												backgroundHeader={this.state.backgroundHeader}
												logoPosition={this.state.logoPosition}
												backgroundHeader1={this.state.backgroundHeader1}
												backgroundHeader2={this.state.backgroundHeader2}
												backgroundHeader3={this.state.backgroundHeader3}
												backgroundHeader4={this.state.backgroundHeader4}
												backgroundHeader5={this.state.backgroundHeader5}
												logoPosition1={this.state.logoPosition1}
												logoPosition2={this.state.logoPosition2}
												logoPosition3={this.state.logoPosition3}
												logoPosition4={this.state.logoPosition4}
												logoPosition5={this.state.logoPosition5}
												updateBackgroundHeaderWithIdx={this.updateBackgroundHeaderWithIdx}
												updateLogoPositionWithIdx={this.updateLogoPositionWithIdx}
												defaultColor1={this.state.defaultColor1}
												defaultColor2={this.state.defaultColor2}
												defaultColor3={this.state.defaultColor3}
												defaultColor4={this.state.defaultColor4}
												defaultColor5={this.state.defaultColor5}
											></GenerateTemplate>
										)}
									</Tab.Pane>

									{this.state.attack_type_name === "Phishing" ||
									this.state.attack_type_name === "QRcode" ||
									this.state.attack_type_name === "Ransomware" ||
									this.state.attack_type_name === "Attachment" ||
									(this.state.attack_type_name === "Vishing" && this.state.targetInteractionType === "inbound") ||
									isAiWhatsapp ||
									this.state.attack_type_name === "Training + Quiz" ? (
										<Tab.Pane eventKey="second">
											<AttackProfile
												senderId={this.state.senderId}
												senderType={this.state.senderType}
												handleSenderId={this.handleSenderId}
												handleTabChange={this.handleTabChange}
												handleSenderType={this.handleSenderType}
												campaignTemplateId={this.state.campaignTemplateId}
												attackType={this.state.attack_type_name}
												targetInteractionType={this.state.targetInteractionType }
												isAIbased={this.state.isAIbased}
											></AttackProfile>
										</Tab.Pane>
									) : null}
											
											{((this.state.attack_type_name === "Vishing" && this.state.targetInteractionType === "inbound") || isAiWhatsapp)? (
												<Tab.Pane eventKey="third_ai_conversation">
													<AiConversation
														aiVishingPromptId={this.state.aiVishingPromptId}
														aiWhatsappPromptId={this.state.aiWhatsappPromptId}
														vishingVoiceSelectionId={this.state.vishingVoiceSelectionId}
														handleAiVishingPromptId={this.handleAiVishingPromptId}
														handleAiWhatsappPromptId={this.handleAiWhatsappPromptId}
														handleTabChange={this.handleTabChange}
														campaignTemplateId={this.state.campaignTemplateId}
														attackType={this.state.attack_type_name}
														promptType={isAiWhatsapp ? "whatsapp" : "vishing"}
													></AiConversation>
												</Tab.Pane>
											):null}
											{this.state.attack_type_name === "Vishing" && this.state.targetInteractionType === "inbound" ? (
												<Tab.Pane eventKey="voice_selection">
													<VoiceSelection
														handleTabChange={this.handleTabChange}
														vishingVoiceSelectionId={this.state.vishingVoiceSelectionId}
														campaignTemplateId={this.state.campaignTemplateId}
														onVishingVoiceSelectionCreated={this.handleVishingVoiceSelectionCreated}
														onVoiceSelectionStepComplete={this.handleVoiceSelectionStepComplete}
													></VoiceSelection>
												</Tab.Pane>
											):null}
											{this.state.attack_type_name === "Telegram" ? (
												<Tab.Pane eventKey="second-telegram">
													<AttackProfileTelegram
														senderId={this.state.senderId}
														handleSenderId={this.handleSenderId}
														handleTabChange={this.handleTabChange}
														campaignTemplateId={this.state.campaignTemplateId}
													></AttackProfileTelegram>
												</Tab.Pane>
											):null}

											{this.state.attack_type_name === "Smishing" ? (
												<Tab.Pane eventKey="second-sms">
													<AttackProfileSMS
														senderId={this.state.senderId}
														handleSenderId={this.handleSenderId}
														handleTabChange={this.handleTabChange}
														campaignTemplateId={this.state.campaignTemplateId}
													></AttackProfileSMS>
												</Tab.Pane>
											) : null}
											{isNormalWhatsapp ? (
												<Tab.Pane eventKey="second-sms">
													<AttackProfileWhatsApp
														senderId={this.state.senderId}
														handleSenderId={this.handleSenderId}
														handleTabChange={this.handleTabChange}
														campaignTemplateId={this.state.campaignTemplateId}
														handleWhatsappGateway={this.handleWhatsappGateway}
													></AttackProfileWhatsApp>
												</Tab.Pane>
											) : null}
											{(this.state.attack_type_name === "Vishing" && this.state.targetInteractionType === "outbound") ? (
												<Tab.Pane eventKey="second-call">
													<AttackProfileCall
														senderId={this.state.senderId}
														handleSenderId={this.handleSenderId}
														handleTabChange={this.handleTabChange}
														campaignTemplateId={this.state.campaignTemplateId}
													></AttackProfileCall>
												</Tab.Pane>
											) : null}
											{(this.state.attack_type_name === "Phishing" || 
												this.state.attack_type_name === "Ransomware" || 
												this.state.attack_type_name === "QRcode" || 
												(this.state.attack_type_name === "Vishing" && this.state.targetInteractionType === "inbound") ||
												isAiWhatsapp
											) ? (
												<Tab.Pane eventKey="third">
													<Templates
														templateId={this.state.templateId}
														subContent={this.state.subContent}
														handleTabChange={this.handleTabChange}
														handleTemplateId={this.handleTemplateId}
														campaignTemplateId={this.state.campaignTemplateId}
														templateResponse={this.state.templateResponse}
														currentIndex={this.state.currentIndex}
														defaultColor={this.state.defaultColor}
														updateBackgroundHeader={this.updateBackgroundHeader}
														updateLogoPosition={this.updateLogoPosition}
														backgroundHeader={this.state.backgroundHeader}
														logoPosition={this.state.logoPosition}
														attackType={this.state.attack_type_name}
														targetInteractionType={this.state.targetInteractionType}
														isAIbased={this.state.isAIbased}
													></Templates>
												</Tab.Pane>
											) : null}
											{this.state.attack_type_name === "Attachment" ? (
												<Tab.Pane eventKey="third">
													<AttachmentTemplate
														templateId={this.state.templateId}
														subContent={this.state.subContent}
														handleTabChange={this.handleTabChange}
														handleTemplateId={this.handleTemplateId}
														campaignTemplateId={this.state.campaignTemplateId}
														templateResponse={this.state.templateResponse}
														currentIndex={this.state.currentIndex}
														defaultColor={this.state.defaultColor}
														updateBackgroundHeader={this.updateBackgroundHeader}
														updateLogoPosition={this.updateLogoPosition}
														backgroundHeader={this.state.backgroundHeader}
														logoPosition={this.state.logoPosition}
													></AttachmentTemplate>
												</Tab.Pane>
											) : null}
											
											{this.state.attack_type_name === "Telegram" ? (
												<Tab.Pane eventKey="third-telegram">
													<TemplatesTelegram
														senderId={this.state.senderId}
														templateId={this.state.templateId}
														handleTabChange={this.handleTabChange}
														handleTemplateId={this.handleTemplateId}
														campaignTemplateId={this.state.campaignTemplateId}
													></TemplatesTelegram>
												</Tab.Pane>
											):null}

											{this.state.attack_type_name === "Smishing" ? (
												<Tab.Pane eventKey="third-sms">
													<TemplatesSMS
														templateId={this.state.templateId}
														handleTabChange={this.handleTabChange}
														handleTemplateId={this.handleTemplateId}
														campaignTemplateId={this.state.campaignTemplateId}
													></TemplatesSMS>
												</Tab.Pane>
											) : null}
											{isNormalWhatsapp ? (
												<Tab.Pane eventKey="third-sms">
													<TemplatesWhatsApp
														senderId={this.state.senderId}
														templateId={this.state.templateId}
														handleTabChange={this.handleTabChange}
														handleTemplateId={this.handleTemplateId}
														campaignTemplateId={this.state.campaignTemplateId}
														whatsappGateway={this.state.whatsappGateway}
													></TemplatesWhatsApp>
												</Tab.Pane>
											) : null}
											{(this.state.attack_type_name === "Vishing" && this.state.targetInteractionType === "outbound") ? (
												<Tab.Pane eventKey="third-call">
													<TemplatesCall
														templateId={this.state.templateId}
														handleTabChange={this.handleTabChange}
														handleTemplateId={this.handleTemplateId}
														campaignTemplateId={this.state.campaignTemplateId}
													></TemplatesCall>
												</Tab.Pane>
											) : null}
											<Tab.Pane eventKey="fourth">
												<Pages
													pageId={this.state.pageId}
													handlePageId={this.handlePageId}
													handleTabChange={this.handleTabChange}
													attack_type_name={this.state.attack_type_name}
													campaignTemplateId={this.state.campaignTemplateId}
												></Pages>
											</Tab.Pane>
											{this.state.attack_type_name === "Ransomware" ? (
												<Tab.Pane eventKey="fifth" mountOnEnter>
													<RansomwareFile
														pageId={this.state.pageId}
														campaignTemplateId={this.state.campaignTemplateId}
														isActive={this.state.activeTab === "fifth"}
														handleTabChange={this.handleTabChange}
														onRansomwareFileComplete={this.handleRansomwareFileComplete}
													></RansomwareFile>
												</Tab.Pane>
											) : null}
											<Tab.Pane eventKey="six">
												{this.state.simulation_type_name === "Awareness Training" && (
													<Training
														trainingId={this.state.trainingId}
														handleTraining={this.handleTraining}
														handleTabChange={this.handleTabChange}
														campaignTemplateId={this.state.campaignTemplateId}
														sendCourseTemplateId={this.state.sendCourseTemplateId}
														courseCompletionTemplateId={this.state.courseCompletionTemplateId}
														courseQuizFailReminderTemplateId={this.state.courseQuizFailReminderTemplateId}
														sendQuizTemplateId={this.state.sendQuizTemplateId}
													></Training>
												)}
											</Tab.Pane>
											<Tab.Pane eventKey="seven">
												<Game
													gameId={this.state.gameId}
													handleTabChange={this.handleTabChange}
													campaignTemplateId={this.state.campaignTemplateId}
												></Game>
											</Tab.Pane>
											{this.state.attack_type_name !== "Ransomware" && (
												<Tab.Pane eventKey="eight">
													<AwarenessPages
														pageId={this.state.pageId}
														handlePageId={this.handlePageId}
														handleTabChange={this.handleTabChange}
														attack_type_name={this.state.attack_type_name}
														campaignTemplateId={this.state.campaignTemplateId}
														handleAwarenessPageId={this.handleAwarenessPageId}
													></AwarenessPages>
												</Tab.Pane>
											)}
											<Tab.Pane eventKey="nine">
												<Preview
													key={this.state.campaignTemplateId || "new-template"}
													nextPath={this.nextPath}
													campaignTemplateId={this.state.campaignTemplateId}
												></Preview>
											</Tab.Pane>
								</Tab.Content>
							</div>
						</div>
					</Tab.Container>
				</div>
				{this.state.loading ? <Loader></Loader> : null}
			</div>
		);
	}
}
